/* Pure display model. Shopify remains the source of truth for money and discounts. */
(function(root){
  function properties(item){return Array.isArray(item.properties)?item.properties:Object.entries(item.properties||{});}
  function supported(cart){return !!cart&&cart.currency==='PLN'&&Array.isArray(cart.items)&&cart.items.every(i=>i.key&&!i.nested&&Number(i.step||1)===1&&Number(i.min||1)===1&&Number.isInteger(i.final_line_price));}
  function group(cart){
    const groups=new Map();
    for(const item of cart.items){
      const merge=item.eligible&&!item.selling_plan&&!properties(item).length&&item.can_update!==false&&item.can_remove!==false;
      const key=merge?'variant:'+item.id:'line:'+item.key;
      if(!groups.has(key))groups.set(key,{key,item,lines:[],quantity:0,original:0,total:0,free:0});
      const g=groups.get(key);g.lines.push(item);g.quantity+=item.quantity;g.original+=item.original_line_price;g.total+=item.final_line_price;
      if(item.final_line_price===0&&item.original_line_price>0)g.free+=item.quantity;
    }
    return [...groups.values()];
  }
  function change(g,action){
    if(action==='remove'){
      if(g.lines.some(i=>i.can_remove===false))return null;
      return {endpoint:'cart/update.js',body:{updates:Object.fromEntries(g.lines.map(i=>[i.key,0]))}};
    }
    if(!['plus','minus'].includes(action)||g.lines.some(i=>i.can_update===false))return null;
    // One server-validated change. Never consolidate quantities with update.js,
    // which does not validate stock on existing lines. Removal may batch zeroes.
    const line=action==='minus'?g.lines[g.lines.length-1]:g.lines[0];
    if(action==='minus'&&g.quantity===1&&line.can_remove===false)return null;
    if(action==='plus'&&line.max!=null&&g.quantity>=line.max)return null;
    return {endpoint:'cart/change.js',body:{id:line.key,quantity:line.quantity+(action==='plus'?1:-1)}};
  }
  const api={supported,group,change,properties};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.SPDrawerModel=api;
})(typeof window!=='undefined'?window:globalThis);
